import { CFM_AUTO_DISCOUNTS } from '@ourbranch/lookups';
import type { BrandProduct } from '../types';

export const cfm = {
  identity: {
    SHORT_NAME: 'CFM',
    FULL_NAME: 'CFM Insurance',
    LEGAL_NAME: 'CFM Insurance, Inc',
    EMAIL_SENDER: 'CFM Insurance',
    EMAIL_BCC: 'info@cfmimo.com',
    SUPPORT_NAME: 'CFM Insurance',
    DOMAIN: 'cfmimo.com',
    SUPPORT_EMAIL: 'info@cfmimo.com',
    DISPLAY_NAME: 'CFM',
    MARKETING_NAME: 'CFM Insurance',
    POLICY_ISSUER: 'CFM Insurance',
    CLAIMS_HANDLER: 'CFM',
    REFERRAL_NAME: 'CFM Insurance',
    SOCIAL_HANDLE: 'CFM',
    AGENCY_SUPPORT_EMAIL: 'info@cfmimo.com',
    // brand-config-be keeps these two split into lines (PAYMENT_ADDRESS_LINES /
    // EXPEDITED_PAYMENT_ADDRESS_LINES); its payment-address.test.ts checks the two agree.
    PAYMENT_ADDRESS: 'CFM Insurance, Inc PO Box 15143 Worcester, MA 01615',
    EXPEDITED_PAYMENT_ADDRESS: 'CFM Insurance, Inc 370 Main St, Ste 880 Worcester, MA 01608',
    CUSTOMER_SERVICE_PHONE: '800-218-2223',
    CUSTOMER_SERVICE_PHONE_LETTERS: '800-218-2223',
    PRIVACY_POLICY_URL: 'https://cfmimo.com/privacy-policy/'
  },
  supportedStates: ['MO'],
  // Underwriter-selectable supplemental documents for the Policy Settings page (#34376). Appended
  // to the farm policy packet when selected. PDFs live in the carrier policy_docs bucket under
  // these keys (the Blanket Inventory List shares its filename with Forreston's).
  supplementalDocuments: [
    {
      id: 'solid-fuel-wood-heat-checklist',
      label: 'Solid Fuel and Wood Heat Supplement Checklist',
      s3Key: 'supplemental-documents/solid-fuel-wood-heat-checklist.pdf'
    },
    {
      id: 'blanket-inventory-list',
      label: 'Blanket Inventory List',
      s3Key: 'supplemental-documents/farm-blanket-inventory.pdf'
    },
    // #35891: CFM's own Recurring Payment Authorization form. Also attachable to auto policies —
    // the only catalog entry with an explicit policyTypes scope. s3Key must stay in lockstep with
    // recurringPaymentAuthorizationS3Key in brand-config-be's cfm.ts.
    {
      id: 'recurring-payment-authorization',
      label: 'Recurring Payment Authorization Form',
      s3Key: 'supplemental-documents/recurring-payment-authorization.pdf',
      policyTypes: ['F', 'Z', 'Y', 'A']
    }
  ],
  // CFM auto offers Multi Car, Homeowner, Paid in Full, Transfer, Renewal, Claims Free and Violation
  // Free — no Community Drive, paperless, employee or multiline (#35626).
  autoDiscounts: CFM_AUTO_DISCOUNTS,
  // Hold rateControlDate up to 5 days by default, 60 for underwriters (issue #32130).
  rateControlDate: { maxStaleDaysToBind: 5, underwriterMaxHoldDays: 60 },
  // Mutual: 15-day billing-hold cap, reason required, "hold cancellations as well" option available (#33568).
  billingHold: { maxDays: 15, teamLeaderMaxDays: 30, requireReason: true, holdCancellationsEnabled: true },
  // Agents send the insured's signed cancellation request to underwriting instead of cancelling (#37502).
  agentCancellationRequestEmail: 'UWReview@cfmimo.com',
  // Transportation Expense rides with Comprehensive alone, and $30/day comes with it at no charge (underwriting-rules
  // cfm #normalizeCarCoverages). Roadside needs neither Comprehensive nor Collision, so a liability-only car can carry
  // it (trailers never get it). CFM files no Lease/Loan Gap coverage, so it is never offered (#37627); underwriting-rules'
  // CFM AutoPostDataRules also turns it off on every car.
  autoCoverageDependencies: {
    rentalRequiresCollision: false,
    roadsideRequiresCollision: false,
    loanRequiresPhysicalDamage: false,
    leaseLoanOffered: false,
    includedRentalLimit: '30'
  }
} satisfies BrandProduct;
